var map = {
	"./": [
		72812,
		9
	],
	"./App": [
		19349,
		9
	],
	"./App.css": [
		44050,
		9
	],
	"./App.js": [
		19349,
		9
	],
	"./App.module.sass": [
		68242,
		9
	],
	"./app-core/AppContext": [
		14088,
		9
	],
	"./app-core/AppContext.js": [
		14088,
		9
	],
	"./components/AdaptiveLogo/AdaptiveLogo": [
		15782,
		9
	],
	"./components/AdaptiveLogo/AdaptiveLogo.jsx": [
		15782,
		9
	],
	"./components/AdaptiveLogo/AdaptiveLogo.module.sass": [
		98673,
		9
	],
	"./components/AdaptiveLogo/imageTone": [
		91194,
		9
	],
	"./components/AdaptiveLogo/imageTone.js": [
		91194,
		9
	],
	"./components/AddLanguageModal": [
		19996,
		9
	],
	"./components/AddLanguageModal/": [
		19996,
		9
	],
	"./components/AddLanguageModal/AddLanguageModal": [
		2688,
		9
	],
	"./components/AddLanguageModal/AddLanguageModal.jsx": [
		2688,
		9
	],
	"./components/AddLanguageModal/AddLanguageModal.module.sass": [
		89343,
		9
	],
	"./components/AddLanguageModal/index": [
		19996,
		9
	],
	"./components/AddLanguageModal/index.js": [
		19996,
		9
	],
	"./components/AdminPanel/AdminPanel": [
		94049,
		9
	],
	"./components/AdminPanel/AdminPanel.jsx": [
		94049,
		9
	],
	"./components/AdminPanel/AdminPanel.module.sass": [
		18933,
		9
	],
	"./components/AdminPanel/ConfigPicker": [
		92663,
		9
	],
	"./components/AdminPanel/ConfigPicker.jsx": [
		92663,
		9
	],
	"./components/AdminPanel/ConfigPicker.module.sass": [
		15352,
		9
	],
	"./components/BrokerProgram/BrokerProgram": [
		43050,
		9
	],
	"./components/BrokerProgram/BrokerProgram.jsx": [
		43050,
		9
	],
	"./components/BrokerProgram/BrokerProgram.module.sass": [
		58485,
		9
	],
	"./components/BrokerProgram/FintechSuccessModal": [
		98688,
		9
	],
	"./components/BrokerProgram/FintechSuccessModal.jsx": [
		98688,
		9
	],
	"./components/BrokerProgram/TransactionCard": [
		39749,
		9
	],
	"./components/BrokerProgram/TransactionCard.jsx": [
		39749,
		9
	],
	"./components/Chat/Chat": [
		98281,
		9
	],
	"./components/Chat/Chat.jsx": [
		98281,
		9
	],
	"./components/Chat/Chat.module.sass": [
		47863,
		9
	],
	"./components/ConfirmDialog/ConfirmDialog": [
		40998,
		9
	],
	"./components/ConfirmDialog/ConfirmDialog.jsx": [
		40998,
		9
	],
	"./components/ConfirmDialog/ConfirmDialog.module.sass": [
		42705,
		9
	],
	"./components/CryptoChart/CryptoChart": [
		2514,
		9
	],
	"./components/CryptoChart/CryptoChart.jsx": [
		2514,
		9
	],
	"./components/CryptoChart/CryptoChart.module.sass": [
		35285,
		9
	],
	"./components/Dashbroad": [
		92185,
		9
	],
	"./components/Dashbroad.jsx": [
		92185,
		9
	],
	"./components/Dashbroad.module.sass": [
		59856,
		9
	],
	"./components/FlagIcon/FlagIcon": [
		80562,
		9
	],
	"./components/FlagIcon/FlagIcon.jsx": [
		80562,
		9
	],
	"./components/GradientLineChart": [
		25959,
		9
	],
	"./components/GradientLineChart.js": [
		25959,
		9
	],
	"./components/Header/Header": [
		62779,
		9
	],
	"./components/Header/Header.jsx": [
		62779,
		9
	],
	"./components/Header/Header.module.sass": [
		61221,
		9
	],
	"./components/LoginScreen/LoginScreen": [
		78494,
		9
	],
	"./components/LoginScreen/LoginScreen.jsx": [
		78494,
		9
	],
	"./components/LoginScreen/LoginScreen.module.sass": [
		65545,
		9
	],
	"./components/Mailbox/Mailbox": [
		73886,
		9
	],
	"./components/Mailbox/Mailbox.jsx": [
		73886,
		9
	],
	"./components/Mailbox/Mailbox.module.sass": [
		79753,
		9
	],
	"./components/MiniFigma": [
		25227,
		9
	],
	"./components/MiniFigma/": [
		25227,
		9
	],
	"./components/MiniFigma/MiniFigma": [
		78006,
		9
	],
	"./components/MiniFigma/MiniFigma.jsx": [
		78006,
		9
	],
	"./components/MiniFigma/MiniFigma.module.sass": [
		79289,
		9
	],
	"./components/MiniFigma/index": [
		25227,
		9
	],
	"./components/MiniFigma/index.js": [
		25227,
		9
	],
	"./components/NavBar/NavBar": [
		71165,
		9
	],
	"./components/NavBar/NavBar.jsx": [
		71165,
		9
	],
	"./components/NavBar/NavBar.module.sass": [
		19231,
		9
	],
	"./components/OrderBook/OrderBook": [
		34918,
		9
	],
	"./components/OrderBook/OrderBook.jsx": [
		34918,
		9
	],
	"./components/OrderBook/OrderBook.module.sass": [
		21009,
		9
	],
	"./components/ProgressBar/ProgressBar": [
		22822,
		9
	],
	"./components/ProgressBar/ProgressBar.jsx": [
		22822,
		9
	],
	"./components/ProgressBar/ProgressBar.module.sass": [
		97953,
		9
	],
	"./components/Settings/SecondPart": [
		23270,
		7
	],
	"./components/Settings/SecondPart.js": [
		23270,
		7
	],
	"./components/Settings/Settings": [
		79062,
		9
	],
	"./components/Settings/Settings.jsx": [
		79062,
		9
	],
	"./components/Settings/Settings.module.sass": [
		92617,
		9
	],
	"./components/SettingsPage": [
		60392,
		9
	],
	"./components/SettingsPage/": [
		60392,
		9
	],
	"./components/SettingsPage/SettingsPage": [
		67888,
		9
	],
	"./components/SettingsPage/SettingsPage.jsx": [
		67888,
		9
	],
	"./components/SettingsPage/SettingsPage.module.sass": [
		59183,
		9
	],
	"./components/SettingsPage/_novaTokens.sass": [
		92489,
		9
	],
	"./components/SettingsPage/index": [
		60392,
		9
	],
	"./components/SettingsPage/index.js": [
		60392,
		9
	],
	"./components/SettingsPage/tabs/AuditLogsTab": [
		99030,
		9
	],
	"./components/SettingsPage/tabs/AuditLogsTab.jsx": [
		99030,
		9
	],
	"./components/SettingsPage/tabs/AuditLogsTab.module.sass": [
		91737,
		9
	],
	"./components/SettingsPage/tabs/MailTab": [
		25997,
		9
	],
	"./components/SettingsPage/tabs/MailTab.jsx": [
		25997,
		9
	],
	"./components/SettingsPage/tabs/MailTab.module.sass": [
		39158,
		9
	],
	"./components/SettingsPage/tabs/ModalStepsTab": [
		41350,
		9
	],
	"./components/SettingsPage/tabs/ModalStepsTab.jsx": [
		41350,
		9
	],
	"./components/SettingsPage/tabs/ModalStepsTab.module.sass": [
		39729,
		9
	],
	"./components/SettingsPage/tabs/SapsTab": [
		5827,
		9
	],
	"./components/SettingsPage/tabs/SapsTab.jsx": [
		5827,
		9
	],
	"./components/SettingsPage/tabs/SapsTab.module.sass": [
		3380,
		9
	],
	"./components/SettingsPage/tabs/SentEmailsTab": [
		34369,
		9
	],
	"./components/SettingsPage/tabs/SentEmailsTab.jsx": [
		34369,
		9
	],
	"./components/SettingsPage/tabs/SentEmailsTab.module.sass": [
		17350,
		9
	],
	"./components/SettingsPage/tabs/UserStats": [
		48579,
		9
	],
	"./components/SettingsPage/tabs/UserStats.jsx": [
		48579,
		9
	],
	"./components/SettingsPage/tabs/UserStats.module.sass": [
		52938,
		9
	],
	"./components/SettingsPage/tabs/UsersTab": [
		18794,
		9
	],
	"./components/SettingsPage/tabs/UsersTab.jsx": [
		18794,
		9
	],
	"./components/SettingsPage/tabs/UsersTab.module.sass": [
		24773,
		9
	],
	"./components/SiteSettings/SiteSettings": [
		23032,
		9
	],
	"./components/SiteSettings/SiteSettings.jsx": [
		23032,
		9
	],
	"./components/SiteSettings/SiteSettings.jsx.backup": [
		79689,
		1
	],
	"./components/SiteSettings/SiteSettings.jsx.bak": [
		50187,
		1
	],
	"./components/SiteSettings/SiteSettings.jsx.broken": [
		73292,
		1
	],
	"./components/SiteSettings/SiteSettings.module.sass": [
		44263,
		9
	],
	"./components/Toast": [
		88369,
		9
	],
	"./components/Toast/": [
		88369,
		9
	],
	"./components/Toast/Toast": [
		88234,
		9
	],
	"./components/Toast/Toast.jsx": [
		88234,
		9
	],
	"./components/Toast/Toast.module.sass": [
		74221,
		9
	],
	"./components/Toast/index": [
		88369,
		9
	],
	"./components/Toast/index.js": [
		88369,
		9
	],
	"./components/ToggleSwitch/ToggleSwitch": [
		53404,
		9
	],
	"./components/ToggleSwitch/ToggleSwitch.jsx": [
		53404,
		9
	],
	"./components/ToggleSwitch/ToggleSwitch.module.sass": [
		47043,
		9
	],
	"./components/TradingDashboard/TradingDashboard": [
		53154,
		9
	],
	"./components/TradingDashboard/TradingDashboard.jsx": [
		53154,
		9
	],
	"./components/TradingDashboard/TradingDashboard.module.sass": [
		3397,
		9
	],
	"./components/TransactionTable/TransactionTable": [
		49236,
		9
	],
	"./components/TransactionTable/TransactionTable.jsx": [
		49236,
		9
	],
	"./components/TransactionTable/TransactionTable.module.sass": [
		54683,
		9
	],
	"./components/Wallet/Button": [
		97329,
		9
	],
	"./components/Wallet/Button.jsx": [
		97329,
		9
	],
	"./components/Wallet/Wallet": [
		44178,
		9
	],
	"./components/Wallet/Wallet.jsx": [
		44178,
		9
	],
	"./components/Wallet/Wallet.module.sass": [
		28277,
		9
	],
	"./config/api": [
		24227,
		9
	],
	"./config/api.js": [
		24227,
		9
	],
	"./config/defaultSettings": [
		30828,
		3
	],
	"./config/defaultSettings.json": [
		30828,
		3
	],
	"./config/flags": [
		4396,
		9
	],
	"./config/flags.js": [
		4396,
		9
	],
	"./config/languages": [
		3716,
		9
	],
	"./config/languages.js": [
		3716,
		9
	],
	"./hooks": [
		61139,
		9
	],
	"./hooks/": [
		61139,
		9
	],
	"./hooks/index": [
		61139,
		9
	],
	"./hooks/index.js": [
		61139,
		9
	],
	"./hooks/useToast": [
		72725,
		9
	],
	"./hooks/useToast.js": [
		72725,
		9
	],
	"./hooks/useTranslation": [
		91685,
		9
	],
	"./hooks/useTranslation.js": [
		91685,
		9
	],
	"./img/Bitcoin.svg.png": [
		47532,
		1
	],
	"./img/Ethereum-ETH-icon.png": [
		6675,
		1
	],
	"./img/Graphic.png": [
		84202,
		1
	],
	"./img/ICBC.png": [
		42533,
		1
	],
	"./img/about.png": [
		67569,
		1
	],
	"./img/add.png": [
		34567,
		1
	],
	"./img/android.png": [
		10335,
		1
	],
	"./img/apple.png": [
		93974,
		1
	],
	"./img/arg.png": [
		33254,
		1
	],
	"./img/arg.svg": [
		99804,
		1
	],
	"./img/arrow.svg": [
		30195,
		1
	],
	"./img/assetdistribution.png": [
		66132,
		1
	],
	"./img/astropay.png": [
		72530,
		1
	],
	"./img/bank.png": [
		22926,
		1
	],
	"./img/bankicons/AmBank.png": [
		19735,
		1
	],
	"./img/bankicons/Bank of Singapore.png": [
		68812,
		1
	],
	"./img/bankicons/Bank_Rakyat_Malaysia.png": [
		410,
		1
	],
	"./img/bankicons/BigPay.png": [
		19995,
		1
	],
	"./img/bankicons/Boost.png": [
		34250,
		1
	],
	"./img/bankicons/CIMB_Group.png": [
		19434,
		1
	],
	"./img/bankicons/Citibank Singapore.png": [
		25218,
		1
	],
	"./img/bankicons/DBS Bank.png": [
		72874,
		1
	],
	"./img/bankicons/DBS PayLah.png": [
		34093,
		1
	],
	"./img/bankicons/EZ-Link Wallet (SimplyGo).png": [
		78009,
		1
	],
	"./img/bankicons/FavePay.png": [
		61353,
		1
	],
	"./img/bankicons/GoPayz.png": [
		32825,
		1
	],
	"./img/bankicons/GrabPay.png": [
		11671,
		1
	],
	"./img/bankicons/HSBC Singapore.png": [
		90023,
		1
	],
	"./img/bankicons/HSBC_Malaysia.png": [
		95247,
		1
	],
	"./img/bankicons/HongLeongBank.png": [
		77022,
		1
	],
	"./img/bankicons/ICBC.png": [
		26150,
		1
	],
	"./img/bankicons/Instapay_eWallet.png": [
		25841,
		1
	],
	"./img/bankicons/Instarem (Nium).png": [
		75028,
		1
	],
	"./img/bankicons/MAE_by_Maybank2u.png": [
		65645,
		1
	],
	"./img/bankicons/Maybank Singapore.png": [
		73364,
		1
	],
	"./img/bankicons/Maybank.png": [
		41714,
		1
	],
	"./img/bankicons/OCBC_Bank_Malaysia.png": [
		96649,
		1
	],
	"./img/bankicons/POSB.png": [
		96187,
		1
	],
	"./img/bankicons/Public_Bank_Berhad.png": [
		32778,
		1
	],
	"./img/bankicons/RHB_Bank.png": [
		21510,
		1
	],
	"./img/bankicons/Revolut.png": [
		37654,
		1
	],
	"./img/bankicons/ShopeePay.png": [
		22695,
		1
	],
	"./img/bankicons/Standard Chartered Singapore.png": [
		89236,
		1
	],
	"./img/bankicons/Touch_n_Go_eWallet.png": [
		13835,
		1
	],
	"./img/bankicons/Trust Bank.png": [
		26883,
		1
	],
	"./img/bankicons/UOB_Malaysia.png": [
		51471,
		1
	],
	"./img/bankicons/Wise_TransferWise.png": [
		76641,
		1
	],
	"./img/bankicons/YouTrip.png": [
		57567,
		1
	],
	"./img/bankicons/alliance.png": [
		65576,
		1
	],
	"./img/bankicons/astropay.png": [
		95318,
		1
	],
	"./img/bankicons/bbva.png": [
		7676,
		1
	],
	"./img/bankicons/belo.png": [
		82387,
		1
	],
	"./img/bankicons/bna.png": [
		11658,
		1
	],
	"./img/bankicons/brubank.png": [
		71424,
		1
	],
	"./img/bankicons/ciudad.png": [
		29855,
		1
	],
	"./img/bankicons/credicoop.png": [
		80349,
		1
	],
	"./img/bankicons/cuentadni.png": [
		16404,
		1
	],
	"./img/bankicons/default-bank.png": [
		45729,
		1
	],
	"./img/bankicons/fiwind.png": [
		95082,
		1
	],
	"./img/bankicons/galicia.png": [
		65297,
		1
	],
	"./img/bankicons/gxbank.png": [
		27276,
		1
	],
	"./img/bankicons/lemon.png": [
		61458,
		1
	],
	"./img/bankicons/macro.png": [
		4823,
		1
	],
	"./img/bankicons/mastercard.png": [
		57967,
		1
	],
	"./img/bankicons/mercadopago.png": [
		10563,
		1
	],
	"./img/bankicons/naranja.png": [
		74738,
		1
	],
	"./img/bankicons/otrobanco.png": [
		42926,
		1
	],
	"./img/bankicons/pampa.png": [
		99508,
		1
	],
	"./img/bankicons/patagonia.png": [
		20853,
		1
	],
	"./img/bankicons/personalpay.png": [
		95849,
		1
	],
	"./img/bankicons/prex.png": [
		88490,
		1
	],
	"./img/bankicons/provincia.png": [
		76166,
		1
	],
	"./img/bankicons/santander.png": [
		75227,
		1
	],
	"./img/bankicons/supervielle.png": [
		16291,
		1
	],
	"./img/bankicons/uala.png": [
		6352,
		1
	],
	"./img/bankicons/visa.png": [
		87860,
		1
	],
	"./img/banksign-green.png": [
		81199,
		1
	],
	"./img/banksign.png": [
		67949,
		1
	],
	"./img/barchart-svgrepo-com.svg": [
		21512,
		1
	],
	"./img/bbva.png": [
		51435,
		1
	],
	"./img/bell-svgrepo-com.svg": [
		6046,
		1
	],
	"./img/belo.png": [
		7200,
		1
	],
	"./img/binance-coin-bnb-logo-CD94CC6D31-seeklogo.com.png": [
		32705,
		1
	],
	"./img/bna.png": [
		19979,
		1
	],
	"./img/broker-program-normal.svg": [
		86656,
		1
	],
	"./img/brokercenter.png": [
		79620,
		1
	],
	"./img/brubank.png": [
		97801,
		1
	],
	"./img/buy.png": [
		32138,
		1
	],
	"./img/buy.webp": [
		58588,
		1
	],
	"./img/calendarik.png": [
		24346,
		1
	],
	"./img/ciudad.png": [
		38828,
		1
	],
	"./img/clock.svg": [
		23954,
		1
	],
	"./img/coms.png": [
		67766,
		1
	],
	"./img/convert.png": [
		39507,
		1
	],
	"./img/credicoop.png": [
		41964,
		1
	],
	"./img/cuentadni.png": [
		2137,
		1
	],
	"./img/dashboard-normal.svg": [
		54180,
		1
	],
	"./img/defi.png": [
		46534,
		1
	],
	"./img/diagram-essential-web-svgrepo-com.svg": [
		96848,
		1
	],
	"./img/done-ring-round-svgrepo-com.svg": [
		9277,
		1
	],
	"./img/enviado24h.png": [
		80554,
		1
	],
	"./img/enviar.png": [
		47571,
		1
	],
	"./img/envvv1.png": [
		59306,
		1
	],
	"./img/envvv2.png": [
		16737,
		1
	],
	"./img/envvv3.png": [
		79256,
		1
	],
	"./img/eurosign.png": [
		536,
		1
	],
	"./img/exit-normal.svg": [
		70416,
		1
	],
	"./img/filter.png": [
		50934,
		1
	],
	"./img/fiwind.png": [
		16721,
		1
	],
	"./img/flagicons/ad.svg": [
		20764,
		1
	],
	"./img/flagicons/ae.svg": [
		32957,
		1
	],
	"./img/flagicons/af.svg": [
		86686,
		1
	],
	"./img/flagicons/ag.svg": [
		6735,
		1
	],
	"./img/flagicons/ai.svg": [
		3481,
		1
	],
	"./img/flagicons/al.svg": [
		45300,
		1
	],
	"./img/flagicons/am.svg": [
		66933,
		1
	],
	"./img/flagicons/ao.svg": [
		93511,
		1
	],
	"./img/flagicons/aq.svg": [
		3569,
		1
	],
	"./img/flagicons/ar.svg": [
		46466,
		1
	],
	"./img/flagicons/arab.svg": [
		32415,
		1
	],
	"./img/flagicons/as.svg": [
		50195,
		1
	],
	"./img/flagicons/asean.svg": [
		99281,
		1
	],
	"./img/flagicons/at.svg": [
		27628,
		1
	],
	"./img/flagicons/au.svg": [
		74989,
		1
	],
	"./img/flagicons/aw.svg": [
		6655,
		1
	],
	"./img/flagicons/ax.svg": [
		96440,
		1
	],
	"./img/flagicons/az.svg": [
		76986,
		1
	],
	"./img/flagicons/ba.svg": [
		16344,
		1
	],
	"./img/flagicons/bb.svg": [
		55179,
		1
	],
	"./img/flagicons/bd.svg": [
		68485,
		1
	],
	"./img/flagicons/be.svg": [
		90468,
		1
	],
	"./img/flagicons/bf.svg": [
		95063,
		1
	],
	"./img/flagicons/bg.svg": [
		48614,
		1
	],
	"./img/flagicons/bh.svg": [
		46769,
		1
	],
	"./img/flagicons/bi.svg": [
		89856,
		1
	],
	"./img/flagicons/bj.svg": [
		80595,
		1
	],
	"./img/flagicons/bl.svg": [
		75661,
		1
	],
	"./img/flagicons/bm.svg": [
		40204,
		1
	],
	"./img/flagicons/bn.svg": [
		2879,
		1
	],
	"./img/flagicons/bo.svg": [
		64942,
		1
	],
	"./img/flagicons/bq.svg": [
		68488,
		1
	],
	"./img/flagicons/br.svg": [
		49851,
		1
	],
	"./img/flagicons/bs.svg": [
		7882,
		1
	],
	"./img/flagicons/bt.svg": [
		63157,
		1
	],
	"./img/flagicons/bv.svg": [
		89735,
		1
	],
	"./img/flagicons/bw.svg": [
		50198,
		1
	],
	"./img/flagicons/by.svg": [
		9168,
		1
	],
	"./img/flagicons/bz.svg": [
		75267,
		1
	],
	"./img/flagicons/ca.svg": [
		7151,
		1
	],
	"./img/flagicons/cc.svg": [
		17597,
		1
	],
	"./img/flagicons/cd.svg": [
		83666,
		1
	],
	"./img/flagicons/cefta.svg": [
		7066,
		1
	],
	"./img/flagicons/cf.svg": [
		57616,
		1
	],
	"./img/flagicons/cg.svg": [
		93153,
		1
	],
	"./img/flagicons/ch.svg": [
		65910,
		1
	],
	"./img/flagicons/ci.svg": [
		29735,
		1
	],
	"./img/flagicons/ck.svg": [
		54133,
		1
	],
	"./img/flagicons/cl.svg": [
		30922,
		1
	],
	"./img/flagicons/cm.svg": [
		91291,
		1
	],
	"./img/flagicons/cn.svg": [
		56904,
		1
	],
	"./img/flagicons/co.svg": [
		22297,
		1
	],
	"./img/flagicons/cp.svg": [
		36686,
		1
	],
	"./img/flagicons/cr.svg": [
		86092,
		1
	],
	"./img/flagicons/cu.svg": [
		19987,
		1
	],
	"./img/flagicons/cv.svg": [
		99232,
		1
	],
	"./img/flagicons/cw.svg": [
		18833,
		1
	],
	"./img/flagicons/cx.svg": [
		37030,
		1
	],
	"./img/flagicons/cy.svg": [
		35063,
		1
	],
	"./img/flagicons/cz.svg": [
		8292,
		1
	],
	"./img/flagicons/de.svg": [
		78234,
		1
	],
	"./img/flagicons/dg.svg": [
		58456,
		1
	],
	"./img/flagicons/dj.svg": [
		69357,
		1
	],
	"./img/flagicons/dk.svg": [
		89644,
		1
	],
	"./img/flagicons/dm.svg": [
		94690,
		1
	],
	"./img/flagicons/do.svg": [
		2784,
		1
	],
	"./img/flagicons/dz.svg": [
		94973,
		1
	],
	"./img/flagicons/eac.svg": [
		53516,
		1
	],
	"./img/flagicons/ec.svg": [
		37319,
		1
	],
	"./img/flagicons/ee.svg": [
		81465,
		1
	],
	"./img/flagicons/eg.svg": [
		97435,
		1
	],
	"./img/flagicons/eh.svg": [
		95196,
		1
	],
	"./img/flagicons/er.svg": [
		96198,
		1
	],
	"./img/flagicons/es-ct.svg": [
		53301,
		1
	],
	"./img/flagicons/es-ga.svg": [
		3580,
		1
	],
	"./img/flagicons/es-pv.svg": [
		91134,
		1
	],
	"./img/flagicons/es.svg": [
		42647,
		1
	],
	"./img/flagicons/et.svg": [
		63928,
		1
	],
	"./img/flagicons/eu.svg": [
		23081,
		1
	],
	"./img/flagicons/fi.svg": [
		35636,
		1
	],
	"./img/flagicons/fj.svg": [
		83847,
		1
	],
	"./img/flagicons/fk.svg": [
		36982,
		1
	],
	"./img/flagicons/fm.svg": [
		81448,
		1
	],
	"./img/flagicons/fo.svg": [
		44522,
		1
	],
	"./img/flagicons/fr.svg": [
		96991,
		1
	],
	"./img/flagicons/ga.svg": [
		92947,
		1
	],
	"./img/flagicons/gb-eng.svg": [
		63543,
		1
	],
	"./img/flagicons/gb-nir.svg": [
		93580,
		1
	],
	"./img/flagicons/gb-sct.svg": [
		43721,
		1
	],
	"./img/flagicons/gb-wls.svg": [
		50575,
		1
	],
	"./img/flagicons/gb.svg": [
		48288,
		1
	],
	"./img/flagicons/gd.svg": [
		34766,
		1
	],
	"./img/flagicons/ge.svg": [
		49407,
		1
	],
	"./img/flagicons/gf.svg": [
		86732,
		1
	],
	"./img/flagicons/gg.svg": [
		17741,
		1
	],
	"./img/flagicons/gh.svg": [
		19738,
		1
	],
	"./img/flagicons/gi.svg": [
		97259,
		1
	],
	"./img/flagicons/gl.svg": [
		95142,
		1
	],
	"./img/flagicons/gm.svg": [
		84119,
		1
	],
	"./img/flagicons/gn.svg": [
		29668,
		1
	],
	"./img/flagicons/gp.svg": [
		41778,
		1
	],
	"./img/flagicons/gq.svg": [
		45091,
		1
	],
	"./img/flagicons/gr.svg": [
		55696,
		1
	],
	"./img/flagicons/gs.svg": [
		46817,
		1
	],
	"./img/flagicons/gt.svg": [
		29438,
		1
	],
	"./img/flagicons/gu.svg": [
		65839,
		1
	],
	"./img/flagicons/gw.svg": [
		75709,
		1
	],
	"./img/flagicons/gy.svg": [
		49403,
		1
	],
	"./img/flagicons/hk.svg": [
		47952,
		1
	],
	"./img/flagicons/hm.svg": [
		70110,
		1
	],
	"./img/flagicons/hn.svg": [
		7933,
		1
	],
	"./img/flagicons/hr.svg": [
		40457,
		1
	],
	"./img/flagicons/ht.svg": [
		25399,
		1
	],
	"./img/flagicons/hu.svg": [
		27366,
		1
	],
	"./img/flagicons/ic.svg": [
		39371,
		1
	],
	"./img/flagicons/id.svg": [
		51044,
		1
	],
	"./img/flagicons/ie.svg": [
		2213,
		1
	],
	"./img/flagicons/il.svg": [
		28844,
		1
	],
	"./img/flagicons/im.svg": [
		11437,
		1
	],
	"./img/flagicons/in.svg": [
		79438,
		1
	],
	"./img/flagicons/io.svg": [
		13900,
		1
	],
	"./img/flagicons/iq.svg": [
		65049,
		1
	],
	"./img/flagicons/ir.svg": [
		73674,
		1
	],
	"./img/flagicons/is.svg": [
		34043,
		1
	],
	"./img/flagicons/it.svg": [
		24276,
		1
	],
	"./img/flagicons/je.svg": [
		32396,
		1
	],
	"./img/flagicons/jm.svg": [
		77892,
		1
	],
	"./img/flagicons/jo.svg": [
		33478,
		1
	],
	"./img/flagicons/jp.svg": [
		8833,
		1
	],
	"./img/flagicons/ke.svg": [
		45515,
		1
	],
	"./img/flagicons/kg.svg": [
		65833,
		1
	],
	"./img/flagicons/kh.svg": [
		55278,
		1
	],
	"./img/flagicons/ki.svg": [
		93215,
		1
	],
	"./img/flagicons/km.svg": [
		70931,
		1
	],
	"./img/flagicons/kn.svg": [
		80192,
		1
	],
	"./img/flagicons/kp.svg": [
		40534,
		1
	],
	"./img/flagicons/kr.svg": [
		8564,
		1
	],
	"./img/flagicons/kw.svg": [
		24217,
		1
	],
	"./img/flagicons/ky.svg": [
		16975,
		1
	],
	"./img/flagicons/kz.svg": [
		37948,
		1
	],
	"./img/flagicons/la.svg": [
		25102,
		1
	],
	"./img/flagicons/lb.svg": [
		8077,
		1
	],
	"./img/flagicons/lc.svg": [
		77068,
		1
	],
	"./img/flagicons/li.svg": [
		85478,
		1
	],
	"./img/flagicons/lk.svg": [
		20004,
		1
	],
	"./img/flagicons/lr.svg": [
		66045,
		1
	],
	"./img/flagicons/ls.svg": [
		53852,
		1
	],
	"./img/flagicons/lt.svg": [
		35427,
		1
	],
	"./img/flagicons/lu.svg": [
		32114,
		1
	],
	"./img/flagicons/lv.svg": [
		37153,
		1
	],
	"./img/flagicons/ly.svg": [
		79734,
		1
	],
	"./img/flagicons/ma.svg": [
		85309,
		1
	],
	"./img/flagicons/mc.svg": [
		93711,
		1
	],
	"./img/flagicons/md.svg": [
		44176,
		1
	],
	"./img/flagicons/me.svg": [
		56417,
		1
	],
	"./img/flagicons/mf.svg": [
		51378,
		1
	],
	"./img/flagicons/mg.svg": [
		89315,
		1
	],
	"./img/flagicons/mh.svg": [
		32884,
		1
	],
	"./img/flagicons/mk.svg": [
		20743,
		1
	],
	"./img/flagicons/ml.svg": [
		936,
		1
	],
	"./img/flagicons/mm.svg": [
		8857,
		1
	],
	"./img/flagicons/mn.svg": [
		64458,
		1
	],
	"./img/flagicons/mo.svg": [
		82299,
		1
	],
	"./img/flagicons/mp.svg": [
		79980,
		1
	],
	"./img/flagicons/mq.svg": [
		59693,
		1
	],
	"./img/flagicons/mr.svg": [
		30574,
		1
	],
	"./img/flagicons/ms.svg": [
		35327,
		1
	],
	"./img/flagicons/mt.svg": [
		93120,
		1
	],
	"./img/flagicons/mu.svg": [
		55921,
		1
	],
	"./img/flagicons/mv.svg": [
		85026,
		1
	],
	"./img/flagicons/mw.svg": [
		64019,
		1
	],
	"./img/flagicons/mx.svg": [
		25476,
		1
	],
	"./img/flagicons/my.svg": [
		80197,
		1
	],
	"./img/flagicons/mz.svg": [
		81062,
		1
	],
	"./img/flagicons/na.svg": [
		41380,
		1
	],
	"./img/flagicons/nc.svg": [
		70118,
		1
	],
	"./img/flagicons/ne.svg": [
		95320,
		1
	],
	"./img/flagicons/nf.svg": [
		29707,
		1
	],
	"./img/flagicons/ng.svg": [
		15098,
		1
	],
	"./img/flagicons/ni.svg": [
		19180,
		1
	],
	"./img/flagicons/nl.svg": [
		51921,
		1
	],
	"./img/flagicons/no.svg": [
		31554,
		1
	],
	"./img/flagicons/np.svg": [
		87221,
		1
	],
	"./img/flagicons/nr.svg": [
		62823,
		1
	],
	"./img/flagicons/nu.svg": [
		89992,
		1
	],
	"./img/flagicons/nz.svg": [
		40239,
		1
	],
	"./img/flagicons/om.svg": [
		87407,
		1
	],
	"./img/flagicons/pa.svg": [
		37618,
		1
	],
	"./img/flagicons/pc.svg": [
		30416,
		1
	],
	"./img/flagicons/pe.svg": [
		17374,
		1
	],
	"./img/flagicons/pf.svg": [
		71549,
		1
	],
	"./img/flagicons/pg.svg": [
		924,
		1
	],
	"./img/flagicons/ph.svg": [
		68539,
		1
	],
	"./img/flagicons/pk.svg": [
		87176,
		1
	],
	"./img/flagicons/pl.svg": [
		6983,
		1
	],
	"./img/flagicons/pm.svg": [
		19862,
		1
	],
	"./img/flagicons/pn.svg": [
		61109,
		1
	],
	"./img/flagicons/pr.svg": [
		42161,
		1
	],
	"./img/flagicons/ps.svg": [
		79360,
		1
	],
	"./img/flagicons/pt.svg": [
		21567,
		1
	],
	"./img/flagicons/pw.svg": [
		66220,
		1
	],
	"./img/flagicons/py.svg": [
		54810,
		1
	],
	"./img/flagicons/qa.svg": [
		94577,
		1
	],
	"./img/flagicons/re.svg": [
		12212,
		1
	],
	"./img/flagicons/ro.svg": [
		53598,
		1
	],
	"./img/flagicons/rs.svg": [
		43898,
		1
	],
	"./img/flagicons/ru.svg": [
		53828,
		1
	],
	"./img/flagicons/rw.svg": [
		19302,
		1
	],
	"./img/flagicons/sa.svg": [
		25983,
		1
	],
	"./img/flagicons/sb.svg": [
		46956,
		1
	],
	"./img/flagicons/sc.svg": [
		94317,
		1
	],
	"./img/flagicons/sd.svg": [
		65794,
		1
	],
	"./img/flagicons/se.svg": [
		69523,
		1
	],
	"./img/flagicons/sg.svg": [
		22897,
		1
	],
	"./img/flagicons/sh-ac.svg": [
		80983,
		1
	],
	"./img/flagicons/sh-hl.svg": [
		6395,
		1
	],
	"./img/flagicons/sh-ta.svg": [
		46850,
		1
	],
	"./img/flagicons/sh.svg": [
		71718,
		1
	],
	"./img/flagicons/si.svg": [
		60695,
		1
	],
	"./img/flagicons/sj.svg": [
		6244,
		1
	],
	"./img/flagicons/sk.svg": [
		3493,
		1
	],
	"./img/flagicons/sl.svg": [
		96314,
		1
	],
	"./img/flagicons/sm.svg": [
		73835,
		1
	],
	"./img/flagicons/sn.svg": [
		15768,
		1
	],
	"./img/flagicons/so.svg": [
		41129,
		1
	],
	"./img/flagicons/sr.svg": [
		40092,
		1
	],
	"./img/flagicons/ss.svg": [
		52285,
		1
	],
	"./img/flagicons/st.svg": [
		18354,
		1
	],
	"./img/flagicons/sv.svg": [
		32272,
		1
	],
	"./img/flagicons/sx.svg": [
		65974,
		1
	],
	"./img/flagicons/sy.svg": [
		12839,
		1
	],
	"./img/flagicons/sz.svg": [
		64628,
		1
	],
	"./img/flagicons/tc.svg": [
		48436,
		1
	],
	"./img/flagicons/td.svg": [
		58203,
		1
	],
	"./img/flagicons/tf.svg": [
		89209,
		1
	],
	"./img/flagicons/tg.svg": [
		7464,
		1
	],
	"./img/flagicons/th.svg": [
		74063,
		1
	],
	"./img/flagicons/tj.svg": [
		84509,
		1
	],
	"./img/flagicons/tk.svg": [
		95036,
		1
	],
	"./img/flagicons/tl.svg": [
		65219,
		1
	],
	"./img/flagicons/tm.svg": [
		50578,
		1
	],
	"./img/flagicons/tn.svg": [
		43713,
		1
	],
	"./img/flagicons/to.svg": [
		8176,
		1
	],
	"./img/flagicons/tr.svg": [
		26373,
		1
	],
	"./img/flagicons/tt.svg": [
		63531,
		1
	],
	"./img/flagicons/tv.svg": [
		17033,
		1
	],
	"./img/flagicons/tw.svg": [
		29144,
		1
	],
	"./img/flagicons/tz.svg": [
		35597,
		1
	],
	"./img/flagicons/ua.svg": [
		78789,
		1
	],
	"./img/flagicons/ug.svg": [
		15947,
		1
	],
	"./img/flagicons/um.svg": [
		38161,
		1
	],
	"./img/flagicons/un.svg": [
		17794,
		1
	],
	"./img/flagicons/unknown.svg": [
		37735,
		1
	],
	"./img/flagicons/us.svg": [
		49063,
		1
	],
	"./img/flagicons/uy.svg": [
		36925,
		1
	],
	"./img/flagicons/uz.svg": [
		99102,
		1
	],
	"./img/flagicons/va.svg": [
		8972,
		1
	],
	"./img/flagicons/vc.svg": [
		59566,
		1
	],
	"./img/flagicons/ve.svg": [
		22112,
		1
	],
	"./img/flagicons/vg.svg": [
		14018,
		1
	],
	"./img/flagicons/vi.svg": [
		54468,
		1
	],
	"./img/flagicons/vn.svg": [
		16619,
		1
	],
	"./img/flagicons/vu.svg": [
		73168,
		1
	],
	"./img/flagicons/wf.svg": [
		14524,
		1
	],
	"./img/flagicons/ws.svg": [
		13681,
		1
	],
	"./img/flagicons/xk.svg": [
		15200,
		1
	],
	"./img/flagicons/xx.svg": [
		12003,
		1
	],
	"./img/flagicons/ye.svg": [
		51445,
		1
	],
	"./img/flagicons/yt.svg": [
		2052,
		1
	],
	"./img/flagicons/za.svg": [
		67280,
		1
	],
	"./img/flagicons/zm.svg": [
		91188,
		1
	],
	"./img/flagicons/zw.svg": [
		23969,
		1
	],
	"./img/galicia.png": [
		2184,
		1
	],
	"./img/gamepad.png": [
		28795,
		1
	],
	"./img/greenmark.png": [
		53788,
		1
	],
	"./img/hidden-icon.png": [
		24836,
		1
	],
	"./img/iconsas/1.png": [
		6872,
		1
	],
	"./img/iconsas/1tarif.png": [
		31766,
		1
	],
	"./img/iconsas/2.png": [
		81363,
		1
	],
	"./img/iconsas/2tarif.png": [
		52711,
		1
	],
	"./img/iconsas/3tarif.png": [
		59892,
		1
	],
	"./img/iconsas/4tarif.png": [
		37605,
		1
	],
	"./img/iconsas/add_button.png": [
		89981,
		1
	],
	"./img/iconsas/additional_sum.png": [
		63306,
		1
	],
	"./img/iconsas/bank_configuration.png": [
		70596,
		1
	],
	"./img/iconsas/bank_conversion_modal.png": [
		56722,
		1
	],
	"./img/iconsas/comission_modal.png": [
		21339,
		1
	],
	"./img/iconsas/comission_size.png": [
		96817,
		1
	],
	"./img/iconsas/crypto_conversion_modal.png": [
		51993,
		1
	],
	"./img/iconsas/currency_rates.png": [
		45528,
		1
	],
	"./img/iconsas/currency_symbol.png": [
		94925,
		1
	],
	"./img/iconsas/custom_values.png": [
		13331,
		1
	],
	"./img/iconsas/deposut_sum.png": [
		30099,
		1
	],
	"./img/iconsas/export_button.png": [
		42272,
		1
	],
	"./img/iconsas/import_button.png": [
		3567,
		1
	],
	"./img/iconsas/name_user_and_chat_preset.png": [
		49087,
		1
	],
	"./img/iconsas/quickactions.png": [
		42207,
		1
	],
	"./img/iconsas/remove_button.png": [
		48754,
		1
	],
	"./img/iconsas/reset_settings_button.png": [
		75347,
		1
	],
	"./img/iconsas/save_button.png": [
		52935,
		1
	],
	"./img/iconsas/site_settings.png": [
		59206,
		1
	],
	"./img/iconsas/success_modal.png": [
		39886,
		1
	],
	"./img/iconsas/tarifs_settings.png": [
		60112,
		1
	],
	"./img/iconsas/tax_modal.png": [
		93268,
		1
	],
	"./img/iconsas/tax_percent.png": [
		54668,
		1
	],
	"./img/iconsas/timezone.png": [
		55136,
		1
	],
	"./img/iconsas/transactions.png": [
		79582,
		1
	],
	"./img/iconsas/user_information.png": [
		1339,
		1
	],
	"./img/iconsas/users_winnings.png": [
		68565,
		1
	],
	"./img/iconsas/verification_modal.png": [
		84694,
		1
	],
	"./img/iconsas/viptarif.png": [
		21898,
		1
	],
	"./img/iconsas/wallets.png": [
		9875,
		1
	],
	"./img/iconsas/znakov_posle_zapyatoi.png": [
		65984,
		1
	],
	"./img/irs-ieagle.png": [
		48450,
		1
	],
	"./img/irs-small1.png": [
		87155,
		1
	],
	"./img/irs-small2.png": [
		91544,
		1
	],
	"./img/irs-stamp.png": [
		87576,
		1
	],
	"./img/irs.png": [
		10202,
		1
	],
	"./img/irsbackgrounds/irs_en.png": [
		90666,
		1
	],
	"./img/irsbackgrounds/irs_es.png": [
		8767,
		1
	],
	"./img/key.png": [
		56183,
		1
	],
	"./img/lemon.png": [
		63451,
		1
	],
	"./img/logo.png": [
		62077,
		1
	],
	"./img/logo1.png": [
		32480,
		1
	],
	"./img/logo2.png": [
		71163,
		1
	],
	"./img/macro.png": [
		86026,
		1
	],
	"./img/mail.png": [
		46833,
		1
	],
	"./img/mailbox-normal.svg": [
		83192,
		1
	],
	"./img/markets-normal.svg": [
		21397,
		1
	],
	"./img/mastercard.png": [
		6236,
		1
	],
	"./img/mercadopago.png": [
		48762,
		1
	],
	"./img/message-circle-dots-svgrepo-com.svg": [
		84226,
		1
	],
	"./img/moneda.png": [
		93026,
		1
	],
	"./img/naranja.png": [
		18803,
		1
	],
	"./img/nastroiki.png": [
		87946,
		1
	],
	"./img/neighborhood-svgrepo-com.svg": [
		21097,
		1
	],
	"./img/options.png": [
		75844,
		1
	],
	"./img/ordercenter.png": [
		23549,
		1
	],
	"./img/otrobanco.png": [
		12479,
		1
	],
	"./img/paint.png": [
		44426,
		1
	],
	"./img/pampa.png": [
		81213,
		1
	],
	"./img/patagonia.png": [
		95668,
		1
	],
	"./img/person-line-drawing-plus-svgrepo-com.svg": [
		45073,
		1
	],
	"./img/person-png.png": [
		86517,
		1
	],
	"./img/person-svgrepo-com.svg": [
		74794,
		1
	],
	"./img/personalpay.png": [
		95520,
		1
	],
	"./img/phone.png": [
		61326,
		1
	],
	"./img/plusik.png": [
		45412,
		1
	],
	"./img/pnl.png": [
		31324,
		1
	],
	"./img/poisk.png": [
		68096,
		1
	],
	"./img/porreports.png": [
		74092,
		1
	],
	"./img/prex.png": [
		6325,
		1
	],
	"./img/provincia.png": [
		24571,
		1
	],
	"./img/qr.png": [
		79853,
		1
	],
	"./img/qr1.png": [
		76240,
		1
	],
	"./img/santander.png": [
		32290,
		1
	],
	"./img/search-svgrepo-com.svg": [
		68877,
		1
	],
	"./img/settings-normal.svg": [
		23457,
		1
	],
	"./img/settings-svgrepo-com.svg": [
		50114,
		1
	],
	"./img/settings.png": [
		26683,
		1
	],
	"./img/shield-check-fill-svgrepo-com.svg": [
		63467,
		1
	],
	"./img/solana.png": [
		8432,
		1
	],
	"./img/somelogo.png": [
		80001,
		1
	],
	"./img/sortirovka.png": [
		24838,
		1
	],
	"./img/squares-four-fill-svgrepo-com.svg": [
		47096,
		1
	],
	"./img/strelkaa.png": [
		94911,
		1
	],
	"./img/supervielle.png": [
		51342,
		1
	],
	"./img/support-chat-normal.svg": [
		37568,
		1
	],
	"./img/support.png": [
		35315,
		1
	],
	"./img/supportChat.png": [
		3817,
		1
	],
	"./img/telegram.webp": [
		46031,
		1
	],
	"./img/tg_image_3444736134.png": [
		27167,
		1
	],
	"./img/tg_image_3753232113.png": [
		83730,
		1
	],
	"./img/three-open-svgrepo-com.svg": [
		704,
		1
	],
	"./img/totalclientes.png": [
		6881,
		1
	],
	"./img/trade-normal.svg": [
		8434,
		1
	],
	"./img/trade.png": [
		79808,
		1
	],
	"./img/triangle-filled-svgrepo-com.svg": [
		18680,
		1
	],
	"./img/triangle-svgrepo-com.svg": [
		58357,
		1
	],
	"./img/tron.png": [
		85241,
		1
	],
	"./img/uala.png": [
		93807,
		1
	],
	"./img/usdclogo.png": [
		35298,
		1
	],
	"./img/user.png": [
		97477,
		1
	],
	"./img/verif.png": [
		15068,
		1
	],
	"./img/verif_shield.png": [
		96074,
		1
	],
	"./img/verified-svgrepo-com.svg": [
		56885,
		1
	],
	"./img/visa.png": [
		23643,
		1
	],
	"./img/visible-icon.png": [
		27420,
		1
	],
	"./img/voskl.svg": [
		85801,
		1
	],
	"./img/wallet-normal.svg": [
		97481,
		1
	],
	"./img/wallet-svgrepo-com.svg": [
		52922,
		1
	],
	"./img/walletincircle.jpg": [
		96558,
		1
	],
	"./img/windows.png": [
		72573,
		1
	],
	"./index": [
		72812,
		9
	],
	"./index.css": [
		59555,
		9
	],
	"./index.js": [
		72812,
		9
	],
	"./logo.svg": [
		69445,
		1
	],
	"./reportWebVitals": [
		89031,
		9
	],
	"./reportWebVitals.js": [
		89031,
		9
	],
	"./setupTests": [
		89472,
		9
	],
	"./setupTests.js": [
		89472,
		9
	],
	"./themes/nova/NovaApp": [
		7525,
		9
	],
	"./themes/nova/NovaApp.jsx": [
		7525,
		9
	],
	"./themes/nova/NovaApp.module.sass": [
		63778,
		9
	],
	"./themes/nova/NovaChart": [
		48284,
		9
	],
	"./themes/nova/NovaChart.jsx": [
		48284,
		9
	],
	"./themes/nova/NovaFigmaSheet": [
		10231,
		9
	],
	"./themes/nova/NovaFigmaSheet.jsx": [
		10231,
		9
	],
	"./themes/nova/NovaFigmaSheet.module.sass": [
		26792,
		9
	],
	"./themes/nova/NovaHeader": [
		15874,
		9
	],
	"./themes/nova/NovaHeader.jsx": [
		15874,
		9
	],
	"./themes/nova/NovaNav": [
		78220,
		9
	],
	"./themes/nova/NovaNav.jsx": [
		78220,
		9
	],
	"./themes/nova/NovaNews": [
		80930,
		9
	],
	"./themes/nova/NovaNews.jsx": [
		80930,
		9
	],
	"./themes/nova/NovaNews.module.sass": [
		71320,
		9
	],
	"./themes/nova/NovaThemeContext": [
		7210,
		9
	],
	"./themes/nova/NovaThemeContext.js": [
		7210,
		9
	],
	"./themes/nova/NovaTicker": [
		87748,
		9
	],
	"./themes/nova/NovaTicker.jsx": [
		87748,
		9
	],
	"./themes/nova/NovaTicker.module.sass": [
		75939,
		9
	],
	"./themes/nova/NovaTooltip": [
		27577,
		9
	],
	"./themes/nova/NovaTooltip.jsx": [
		27577,
		9
	],
	"./themes/nova/NovaTooltip.module.sass": [
		94310,
		9
	],
	"./themes/nova/NovaTrending": [
		65,
		9
	],
	"./themes/nova/NovaTrending.jsx": [
		65,
		9
	],
	"./themes/nova/NovaTrending.module.sass": [
		95646,
		9
	],
	"./themes/nova/captureScreen": [
		15724,
		9
	],
	"./themes/nova/captureScreen.js": [
		15724,
		9
	],
	"./themes/nova/components/BankLogo": [
		90254,
		9
	],
	"./themes/nova/components/BankLogo.jsx": [
		90254,
		9
	],
	"./themes/nova/modals/NovaBankConversionModal": [
		9508,
		9
	],
	"./themes/nova/modals/NovaBankConversionModal.jsx": [
		9508,
		9
	],
	"./themes/nova/modals/NovaCodeModal": [
		97843,
		9
	],
	"./themes/nova/modals/NovaCodeModal.jsx": [
		97843,
		9
	],
	"./themes/nova/modals/NovaCodeModal.module.sass": [
		62244,
		9
	],
	"./themes/nova/modals/NovaCommissionModal": [
		27711,
		9
	],
	"./themes/nova/modals/NovaCommissionModal.jsx": [
		27711,
		9
	],
	"./themes/nova/modals/NovaCommissionModal.module.sass": [
		79488,
		9
	],
	"./themes/nova/modals/NovaConversionModal": [
		76294,
		9
	],
	"./themes/nova/modals/NovaConversionModal.jsx": [
		76294,
		9
	],
	"./themes/nova/modals/NovaPremiumModal": [
		86839,
		9
	],
	"./themes/nova/modals/NovaPremiumModal.jsx": [
		86839,
		9
	],
	"./themes/nova/modals/NovaSuccessModal": [
		6529,
		9
	],
	"./themes/nova/modals/NovaSuccessModal.jsx": [
		6529,
		9
	],
	"./themes/nova/modals/NovaSuccessModal.module.sass": [
		75102,
		9
	],
	"./themes/nova/modals/NovaVerificationModal": [
		7745,
		9
	],
	"./themes/nova/modals/NovaVerificationModal.jsx": [
		7745,
		9
	],
	"./themes/nova/modals/modalKit": [
		52778,
		9
	],
	"./themes/nova/modals/modalKit.jsx": [
		52778,
		9
	],
	"./themes/nova/pages/NovaBroker": [
		35212,
		9
	],
	"./themes/nova/pages/NovaBroker.jsx": [
		35212,
		9
	],
	"./themes/nova/pages/NovaBroker.module.sass": [
		84893,
		9
	],
	"./themes/nova/pages/NovaDashboard": [
		26873,
		9
	],
	"./themes/nova/pages/NovaDashboard.jsx": [
		26873,
		9
	],
	"./themes/nova/pages/NovaDashboard.module.sass": [
		66410,
		9
	],
	"./themes/nova/pages/NovaMailbox": [
		1687,
		9
	],
	"./themes/nova/pages/NovaMailbox.jsx": [
		1687,
		9
	],
	"./themes/nova/pages/NovaMailbox.module.sass": [
		52710,
		9
	],
	"./themes/nova/pages/NovaSettings": [
		20919,
		9
	],
	"./themes/nova/pages/NovaSettings.jsx": [
		20919,
		9
	],
	"./themes/nova/pages/NovaSettings.module.sass": [
		34425,
		9
	],
	"./themes/nova/pages/NovaTrading": [
		73170,
		9
	],
	"./themes/nova/pages/NovaTrading.jsx": [
		73170,
		9
	],
	"./themes/nova/pages/NovaTrading.module.sass": [
		28925,
		9
	],
	"./themes/nova/pages/NovaWallet": [
		53412,
		9
	],
	"./themes/nova/pages/NovaWallet.jsx": [
		53412,
		9
	],
	"./themes/nova/pages/NovaWallet.module.sass": [
		17201,
		9
	],
	"./themes/nova/pages/NovaWithdrawPanel": [
		92721,
		9
	],
	"./themes/nova/pages/NovaWithdrawPanel.jsx": [
		92721,
		9
	],
	"./themes/nova/pages/NovaWithdrawPanel.module.sass": [
		35590,
		9
	],
	"./themes/nova/useFitGrid": [
		23022,
		9
	],
	"./themes/nova/useFitGrid.js": [
		23022,
		9
	],
	"./themes/nova/useNovaPortfolio": [
		81251,
		9
	],
	"./themes/nova/useNovaPortfolio.js": [
		81251,
		9
	],
	"./utils/amountGenerator": [
		66471,
		9
	],
	"./utils/amountGenerator.js": [
		66471,
		9
	],
	"./utils/audit": [
		53449,
		9
	],
	"./utils/audit.js": [
		53449,
		9
	],
	"./utils/configFlagCache": [
		47432,
		9
	],
	"./utils/configFlagCache.js": [
		47432,
		9
	],
	"./utils/configUtils": [
		78185,
		9
	],
	"./utils/configUtils.js": [
		78185,
		9
	],
	"./utils/confirmDialog": [
		93102,
		9
	],
	"./utils/confirmDialog.js": [
		93102,
		9
	],
	"./utils/consoleBlocker": [
		80737,
		9
	],
	"./utils/consoleBlocker.js": [
		80737,
		9
	],
	"./utils/countryNames": [
		9742,
		9
	],
	"./utils/countryNames.js": [
		9742,
		9
	],
	"./utils/dynamicLoader": [
		88772,
		9
	],
	"./utils/dynamicLoader.js": [
		88772,
		9
	],
	"./utils/flagUtils": [
		99501,
		9
	],
	"./utils/flagUtils.js": [
		99501,
		9
	],
	"./utils/fontLoader": [
		9170,
		9
	],
	"./utils/fontLoader.js": [
		9170,
		9
	],
	"./utils/frontendDeterrents": [
		80354,
		9
	],
	"./utils/frontendDeterrents.js": [
		80354,
		9
	],
	"./utils/globalInteractionAudit": [
		2680,
		9
	],
	"./utils/globalInteractionAudit.js": [
		2680,
		9
	],
	"./utils/notify": [
		88133,
		9
	],
	"./utils/notify.js": [
		88133,
		9
	],
	"./utils/permissions": [
		21298,
		9
	],
	"./utils/permissions.js": [
		21298,
		9
	],
	"./utils/plural": [
		27550,
		9
	],
	"./utils/plural.js": [
		27550,
		9
	],
	"./utils/userUtils": [
		48922,
		9
	],
	"./utils/userUtils.js": [
		48922,
		9
	],
	"./utils/walletResolver": [
		23775,
		9
	],
	"./utils/walletResolver.js": [
		23775,
		9
	]
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var ids = map[req], id = ids[0];
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59140;
module.exports = webpackAsyncContext;